<template>
  <table>
    <thead>
      <tr>
        <th class="clickable" @click="sortBy('analyst')">
          Analyst <i class="fas fa-sort-down amber-text text-accent-4" v-show="sortField === 'analyst'" />
        </th>
        <th class="clickable" @click="sortBy('instrument')">
          Instrument <i class="fas fa-sort-down amber-text text-accent-4" v-show="sortField === 'instrument'" />
        </th>
        <th class="clickable" @click="sortBy('points')">
          Points <i class="fas fa-sort-down amber-text text-accent-4" v-show="sortField === 'points'" />
        </th>
        <th>Comment</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="vote in localVotes" :key="vote.id">
        <td>{{ vote.analyst.name }}</td>
        <td>
          <strong>{{ vote.instrument.company.instruments }}</strong>
          &#8226;
          {{ vote.instrument.company.name | pretty }}
        </td>
        <td>{{ vote.points }}</td>
        <td>{{ vote.comment }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'BestBuysNowVoteTable',
  props: {
    votes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localVotes: [],
      sortField: 'analyst',
    };
  },
  watch: {
    votes() {
      if (this.votes.length !== this.localVotes.length) {
        this.localVotes = Array.from(this.votes);
      }
    },
  },
  methods: {
    sortBy(field) {
      this.localVotes.sort((a, b) => {
        switch (field) {
          case 'analyst':
            if (a.analyst.name > b.analyst.name) { return 1; }
            if (a.analyst.name < b.analyst.name) { return -1; }
            return 0;
          case 'instrument':
            if (a.instrument.symbol > b.instrument.symbol) { return 1; }
            if (a.instrument.symbol < b.instrument.symbol) { return -1; }
            return 0;
          case 'points':
            if (a.points > b.points) { return -1; }
            if (a.points < b.points) { return 1; }
            return 0;
          default:
            return Math.random() > 0.5 ? 1 : -1;
        }
      });
      this.sortField = field;
    },
  },
  mounted() {
    this.localVotes = Array.from(this.votes);
  },
};
</script>
